<template>
  <Bar
    :chart-options="chartOptions"
    :chart-data="chartDataProps"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Bar } from "vue-chartjs/legacy";
import axios from "axios";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

export default {
  name: "UsagesChart",
  components: {
    Bar,
  },
  props: {
    chartDataProps: {
      type: Object,
      default: function () {
        return {
          labels: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
          datasets: [
            {
              label: "Total Usages (GB)",
              backgroundColor: "#F5F5FA",
              hoverBackgroundColor: "#194F9F",
              data: [40, 20, 12, 39, 10, 40, 39],
            },
          ],
        };
      },
    },
    chartId: {
      type: String,
      default: "bar-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chartData: {
        labels: ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"],
        datasets: [
          {
            label: "Total Usages (GB)",
            backgroundColor: "#F5F5FA",
            hoverBackgroundColor: "#194F9F",
            data: [40, 20, 12, 39, 10, 40, 39],
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  mounted: function () {
    // this.getLastWeekUsage();
  },

  methods: {
    getLastWeekUsage: function () {
      let _this = this;
      axios
        .get("/get_last_week_usages")
        .then((response) => {
          console.log("Response::", response.data);
          let data = response.data;
          if (data) {
            // let daysOfWeek = Object.keys(data);
            // let values = Object.values(data);
            // _this.chartData.labels = daysOfWeek;
            // _this.chartData.datasets[0].data = [];
            // _this.chartData.datasets[0].data.push(values);
          }
        })
        .catch((error) => {
          console.log("Error::", error);
        })
        .finally((error) => {});
    },
  },
};
</script>
